import { observer } from "mobx-react-lite";
import React from "react";
import { SourceSelect } from "../../../../../../../../_shared";
import { SelectParseFieldFor } from "../../../../../../../administration";
import { useWatchTicketSaveForm } from "../../../../../hooks/useWatchTicketSaveForm";

type Props = {
  field: SelectParseFieldFor<"OD3_Source">;
  name: string;
};

export const OD3_Source_Select = observer((props: Props) => {
  const source = useWatchTicketSaveForm("source");

  return (
    <SourceSelect
      filterByRootId={props.field.onlyChildren && source}
      multiple={props.field.multiple}
      showSearch
      treeNodeFilterProp="label"
    />
  );
});
